module.exports = __webpack_public_path__ + "static/media/qrcode_logo.560f8a0d.png";